import Axios from '@/axios'

/**
 * 获取系统解码日志
 * @param data 统计截止时间 统计时间范围最大2小时
 * @returns Promise
 *
 * 接口权限名：web:idInfo:index
 */
export const GetIdInfoIndex = data => {
  return Axios({
    url: '/device-manager/web-api/id-info/index',
    method: 'POST',
    type: 'json',
    data
  })
}

